// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.groups .group {\n    display: flex;\n    width: 300px;\n    justify-content: space-between;\n}\n.groups .back, .groups .edit {\n    margin-left: 10px;\n}\n.groups .group .name.disabled {\n    color: lightgray;\n}\n.groups .actions {\n    display: flex;\n    justify-content: space-between;\n    width: 140px;\n}\n", ""]);
// Exports
module.exports = exports;
